var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.50004H15V1.66671C15 1.20837 14.625 0.833374 14.1667 0.833374C13.7083 0.833374 13.3333 1.20837 13.3333 1.66671V2.50004H6.66667V1.66671C6.66667 1.20837 6.29167 0.833374 5.83333 0.833374C5.375 0.833374 5 1.20837 5 1.66671V2.50004H4.16667C3.24167 2.50004 2.50833 3.25004 2.50833 4.16671L2.5 15.8334C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8334V4.16671C17.5 3.25004 16.75 2.50004 15.8333 2.50004ZM15 15.8334H5C4.54167 15.8334 4.16667 15.4584 4.16667 15V6.66671H15.8333V15C15.8333 15.4584 15.4583 15.8334 15 15.8334ZM6.66667 8.33337H9.16667C9.625 8.33337 10 8.70837 10 9.16671V11.6667C10 12.125 9.625 12.5 9.16667 12.5H6.66667C6.20833 12.5 5.83333 12.125 5.83333 11.6667V9.16671C5.83333 8.70837 6.20833 8.33337 6.66667 8.33337Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.661a1995.svg";
export { ForwardRef as ReactComponent };